import Api from "@/api"
import { StateLoading } from "@/components/loading/StateLoading"
import { watchImmediate } from "@vueuse/core"
import {
	defineComponent,
	loadLoadable,
	RefQueries,
	useLoadableRef,
	useRouterParam,
	type ReactiveComponent,
} from "vue-utils"
import NotFound from "../NotFound"
import PdfIncidentView from "./PdfIncidentView"

const PdfIncidentViewPage: ReactiveComponent = () => {
	const incidentLogId = useRouterParam("incidentLogId", RefQueries.Int, "replace")
	const incidentLogRef = useLoadableRef(async () => await Api.incidents.getById(incidentLogId.value))

	watchImmediate(incidentLogId, () => void loadLoadable(incidentLogRef))

	function RenderContent() {
		if (incidentLogRef.type !== "done") {
			return null
		}
		const incident = incidentLogRef.result
		if (!incident) {
			return <NotFound />
		}
		return <PdfIncidentView incident={incident} />
	}

	return () => (
		<StateLoading stores={[incidentLogRef]}>
			<RenderContent />
		</StateLoading>
	)
}

export default defineComponent(PdfIncidentViewPage)
